import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import useRouteMatch from '~/hooks/useRouteMatch';
import MoneyBagIcon from '~/icons/icon-money-bag.svg?react';
import { RouteConfig } from '~/routes/routeConfig';
import NavigationSidebarItem from '../NavigationSidebarItem';

const ReferralItem: React.FC = () => {
  const { t } = useTranslation('sidebar');

  const referralLink = RouteConfig.Referral.buildLink();
  const isActive = Boolean(useRouteMatch([referralLink]));

  return (
    <NavigationSidebarItem
      href={RouteConfig.Referral.buildLink()}
      iconComponent={MoneyBagIcon}
      title={t('referral.label')}
      isActive={isActive}
      isSubmenuOpen={false}
    />
  );
};

export default memo(ReferralItem);
